export enum EAgentAuthQueryKey {
  AGENT_AUTH_DETAILS = 'agent-auth-details',
}
